import { render, staticRenderFns } from "./MyResults.vue?vue&type=template&id=9088b418&scoped=true"
import script from "./MyResults.vue?vue&type=script&lang=js"
export * from "./MyResults.vue?vue&type=script&lang=js"
import style0 from "./MyResults.vue?vue&type=style&index=0&id=9088b418&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9088b418",
  null
  
)

export default component.exports